import React from "react"
import "./footer.css"
import { Link } from "react-router-dom"

const Footer = () => {
  return (
    <footer className="footer-main">
      <div className="footer-container">
        {/* Column 1: Logo & Contact */}
        <div className="footer-col footer-col-big">
          <div className="footer-logo">
            <Link to="/"><img src='/images/logoa.png' alt='Farm Radio Trust Logo' /></Link>
          </div>
          <div className="footer-contact">
            <h4>Address</h4>
            <p>Plot number 862 Area 47 Sector 4 Off Msokela Road,<br />from Bwandilo, Mazengera Street</p>
            <h4>Phone</h4>
            <p><a href="tel:+265993449245">+265 993 449 245</a></p>
            <h4>Email</h4>
            <p><a href="mailto:info@farmradiomw.org">info@farmradiomw.org</a></p>
          </div>
        </div>
        {/* Column 2: Publications */}
        <div className="footer-col">
          <h3>Publications</h3>
          <ul>
            <li><Link to="/publications">Latest News</Link></li>
            <li><Link to="/publications">Reports</Link></li>
            <li><Link to="/publications">Events</Link></li>
            <li><Link to="/downloads/mlimi-radio-launch.pdf" target="_blank" rel="noopener noreferrer">Downloads</Link></li>
          </ul>
        </div>
        {/* Column 3: Useful Links */}
        <div className="footer-col">
          <h3>Useful Links</h3>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About FRT</Link></li>
            <li><Link to="/services">Our Services</Link></li>
            <li><Link to="/projects">Projects</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>
        {/* Column 4: Subscribe */}
        <div className="footer-col footer-col-big">
          <h3>Subscribe</h3>
          <p>Get the latest updates and news from Farm Radio Trust.</p>
          <form className="footer-subscribe-form" onSubmit={e => e.preventDefault()}>
            <input
              type="email"
              placeholder="Enter your email"
              required
              className="footer-input"
            />
            <button type="submit" className="footer-btn">Subscribe</button>
          </form>
          {/* Social Media Icons */}
          <div className="footer-social">
            <a href="https://facebook.com/farmradiotrust" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <i className="fab fa-facebook-f"></i>
            </a>
            <a href="https://twitter.com/farmradiotrust" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
              <i className="fab fa-twitter"></i>
            </a>
            <a href="https://www.instagram.com/farmradiotrust" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="https://www.linkedin.com/company/farmradiotrust" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <i className="fab fa-linkedin-in"></i>
            </a>
          </div>
        </div>
      </div>
      <div className="footer-legal">
        <span>© 2025 Farm Radio Trust. Designed By FRT.</span>
      </div>
    </footer>
  )
}

export default Footer
